module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_chapel@3x-bedb9f2fe7e72f8602867ba8b16fe60e.webp";